import { KeywordDomainRankGq, KeywordDomainRankGqProps } from './KeywordDomainRankGq';
import { SerpStatusGq } from './SerpStatusGq';

export interface ContentMissingKeywordGq {
  id: number;
  keyword: string;
  archived: boolean;
  manualArchiveState: boolean;
  archiveTime?: string;
  serpEnabled: boolean;
  serpTaskTime?: string;
  serpResultTime?: string;
  serpStatus: SerpStatusGq;
  serpHasFeaturedSnippet: boolean;
  domainSerpTaskTime?: string;
  domainSerpResultTime?: string;
  fetchingNewVolume: boolean;
  cPC: number;
  volume: number;
  originalVolume: number;
  competition: number;
  processingTime?: string;
  domainRanks: KeywordDomainRankGq[];
}

export const ContentMissingKeywordGqProps = `
  id
  keyword
  archived
  archiveTime
  manualArchiveState
  serpEnabled
  serpTaskTime
  serpResultTime
  serpStatus
  serpHasFeaturedSnippet
  domainSerpTaskTime
  domainSerpResultTime
  fetchingNewVolume
  cPC
  volume
  originalVolume
  competition
  processingTime
  domainRanks { ${KeywordDomainRankGqProps} }
`;
